'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _core = require('lodash/core');

var _core2 = _interopRequireDefault(_core);

var _sdk = require('wave-charts/sdk');

var _sdk2 = _interopRequireDefault(_sdk);

var _index = require('../sfdc-abstract-chart/index.js');

var _index2 = _interopRequireDefault(_index);

var _metadata = require('./metadata.json');

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ref = _sdk2.default.utils;
var constants = ref.constants;
var configUtils = ref.configUtils;
var sceneUtils = ref.sceneUtils;
var columnUtils = ref.columnUtils;
var plotUtils = ref.plotUtils;
var dataUtils = ref.dataUtils;
var rowsUtils = ref.rowsUtils;
var referenceLineUtils = ref.referenceLineUtils;
var ref$1 = _sdk2.default.shapes;
var Layer = ref$1.Layer;
var Point = ref$1.Point;
var runtime = _sdk2.default.runtime;
var chartLayouts = _sdk2.default.chartLayouts;
var time = _sdk2.default.time;
var layoutsUtils = chartLayouts.layoutsUtils;
var multiAxisPadding = constants.SMALL_MULTIPLE.CELL_PADDING;
var CHART_LAYOUT = constants.CHART_LAYOUT;
var MARK = constants.MARK;
var MARK_TYPE = constants.MARK_TYPE;
var VALUETYPE = constants.VALUETYPE;
var SERIES_KEY = constants.SERIES_KEY;
var colorUtils = _sdk2.default.color.colorUtils;
var MEASURE_AXIS = ["measureAxis1", "measureAxis2"];
var DASHED_LINE_WIDTH = 4;
var DASHED = 9;
var TITLE_OFFSET = 8;

function getDefaultMeasureAxis() {
  return {
    showAxis: true,
    showTitle: true,
    title: "",
    showZero: true,
    scale: constants.SCALE.LINEAR,
    titleMaxLines: 1
  };
}

function getDefaultPlot() {
  return {
    column: [],
    mark: MARK_TYPE.BAR,
    axis: MEASURE_AXIS[0]
  };
}
/**
	Base class for Cartesian Charts
	For charts using a Cartesian coordinate system, which has x, y axis. The x, y axis can represent
	a scale on measure(numeric continuous), dimension(categorical discrete) or time(continous).

 */


var AbstractCartesianChart = function (AbstractChart) {
  function AbstractCartesianChart() {
    AbstractChart.apply(this, arguments);
  }

  if (AbstractChart) AbstractCartesianChart.__proto__ = AbstractChart;
  AbstractCartesianChart.prototype = (0, _create2.default)(AbstractChart && AbstractChart.prototype);
  AbstractCartesianChart.prototype.constructor = AbstractCartesianChart;

  AbstractCartesianChart.prototype.getDefaultConfig = function getDefaultConfig() {
    var obj;
    var hasIcon = configUtils.hasIcon(this.config.dimensionAxis);
    return _core2.default.extend(AbstractChart.prototype.getDefaultConfig.call(this), (obj = {
      plots: configUtils.getPlotsDefaults(this.config),
      r: {
        column: [],
        maxRadius: MARK.POINT.RADIUS
      },
      dimensionAxis: {
        column: [],
        showAxis: true,
        showTitle: true,
        titleMaxLines: 1
      },
      timeAxis: {
        column: [],
        showAxis: true,
        showTitle: true,
        titleMaxLines: 1
      }
    }, obj[MEASURE_AXIS[0]] = getDefaultMeasureAxis(), obj[MEASURE_AXIS[1]] = getDefaultMeasureAxis(), obj.barSize = hasIcon ? constants.ICON.SIZE : MARK.BAR.SIZE, obj.barSpacer = MARK.BAR.SPACER, obj.labelSize = hasIcon ? constants.ICON.SIZE : MARK.LINE.LABEL_SIZE, obj.lineWidth = MARK.LINE.LINE_WIDTH, obj.pointRadius = MARK.LINE.POINT_RADIUS, obj.showPoints = false, obj.fillArea = false, obj.missingValue = constants.MISSING_VALUE.DISCONNECT, obj.mode = constants.CHART_MODE.CLUSTER, obj.normalize = false, obj.autoFitMode = constants.AUTOFIT_MODE.SCROLL, obj.axisMode = constants.AXIS_MODE.DUAL, obj.alignTicks = false, obj.transforms = {
      rotate: false
    }, obj.hasNiceDomain = true, obj));
  };

  AbstractCartesianChart.prototype.isAxisModeMulti = function isAxisModeMulti() {
    return this.config.axisMode == constants.AXIS_MODE.MULTI;
  };

  AbstractCartesianChart.prototype.getChartProperties = function getChartProperties() {
    var config = this.config;
    var plots = config.plots;
    var timeAxis = config.timeAxis;
    var dimensionAxis = config.dimensionAxis;
    var measureAxis1 = config.measureAxis1;
    var measureAxis2 = config.measureAxis2;
    var splitColumn = configUtils.getColumns(config, "split")[0];
    var isStack = !!splitColumn;
    var plotColumns = configUtils.getColumns(config, "plots");
    var timeColumn = configUtils.getColumns(config, "timeAxis")[0];
    var radiusColumn = configUtils.getColumns(config, "r")[0];
    var axisY = timeColumn ? timeAxis : dimensionAxis;
    var yColumns = timeColumn ? [timeColumn] : configUtils.getColumns(config, "dimensionAxis");
    var keyColumns = columnUtils.uniqueColumns(yColumns, splitColumn);
    var hasTime = !!timeColumn;
    var supportsSorting = !hasTime;

    var marks = _core2.default.map(plots, "mark");

    var hasLine = marks.indexOf(MARK_TYPE.LINE) > -1;
    var hasDot = marks.indexOf(MARK_TYPE.DOT) > -1;
    var hasSeries = configUtils.hasSeries(plots);
    var axisNamesMap = {};
    var axisX;

    if (this.isAxisModeMulti()) {
      axisX = _core2.default.map(plots, function (plot) {
        return config[plot.axis];
      });
    } else {
      axisX = [measureAxis1, measureAxis2];
    }

    var labelCellSize = configUtils.getCustomCellSize(axisY);
    var cellSizes = {};

    if (labelCellSize && axisY.showAxis) {
      // note: showAxis wins over custom size
      cellSizes.axisY = labelCellSize + "%";
      cellSizes.plot = 100 - labelCellSize + "%";
    }

    var percentGroupColumns = isStack && !splitColumn ? keyColumns : keyColumns.slice(0, keyColumns.length - 1);
    var tooltipColumns = configUtils.getTooltipColumns(config, "dimensionAxis", "timeAxis", "plots", "r", "split");
    var multiAxisTitleLines = this.isAxisModeMulti() ? plots.reduce(function (max, plot) {
      return Math.max(max, config[plot.axis].titleMaxLines);
    }, 0) : 0;
    return {
      layout: "Cartesian",
      hasTime: hasTime,
      isStack: isStack,
      hasSeries: hasSeries,
      hasLine: hasLine,
      hasDot: hasDot,
      keyColumns: keyColumns,
      percentGroupColumns: percentGroupColumns,
      measureColumns: plotColumns,
      plotColumns: plotColumns,
      timeColumn: timeColumn,
      radiusColumn: radiusColumn,
      splitColumn: splitColumn,
      yColumns: yColumns,
      cellSizes: cellSizes,
      axisX: axisX,
      axisY: axisY,
      marks: marks,
      tooltipColumns: tooltipColumns,
      supportsSorting: supportsSorting,
      axisTitleMaxLines: [hasTime ? timeAxis.titleMaxLines : dimensionAxis.titleMaxLines, multiAxisTitleLines || measureAxis1 && measureAxis1.titleMaxLines || 0, multiAxisTitleLines || measureAxis2 && measureAxis2.titleMaxLines || 0]
    };
  }; // we handle internal sorting in getChartLayouts below


  AbstractCartesianChart.prototype.getInternalSortFct = function getInternalSortFct() {
    return null;
  };

  AbstractCartesianChart.prototype.getColorLayout = function getColorLayout() {
    return AbstractChart.prototype.getColorLayout.call(this, {
      rows: this.chartProperties.hasSeries ? _core2.default.filter(this.rows, function (row) {
        return !row[SERIES_KEY];
      }) : this.rows
    });
  };

  AbstractCartesianChart.prototype.getChartLayouts = function getChartLayouts() {
    var chartLayouts = AbstractChart.prototype.getChartLayouts.call(this);
    var config = this.config;
    var ref = this.chartProperties;
    var axisX = ref.axisX;
    var hasTime = ref.hasTime;
    var hasSeries = ref.hasSeries;
    var yColumns = ref.yColumns;
    var marks = ref.marks;
    var keyColumns = ref.keyColumns;
    var r = config.r;
    var timeAxis = config.timeAxis;
    var dimensionAxis = config.dimensionAxis;
    var size = config.size;
    var padding = config.padding;
    var normalize = config.normalize;
    var hasNiceDomain = config.hasNiceDomain;
    var barSize = config.barSize;
    var barSpacer = config.barSpacer;
    var labelSize = config.labelSize;
    var pointRadius = config.pointRadius;
    var autoFitMode = config.autoFitMode;
    var transforms = config.transforms; // radiusLayout

    var radiusLayout = layoutsUtils.getChartRadiusLayout(r, size, padding, this.rows); // y axis layout

    var yAxisLayout;
    var plotOptions = {
      marks: marks,
      barSize: barSize,
      barSpacer: barSpacer,
      labelSize: labelSize,
      pointRadius: pointRadius,
      isAxisModeMulti: this.isAxisModeMulti()
    };

    if (!hasTime) {
      // categorical y axis
      var rows = this.rows;

      if (hasSeries) {
        // only consider main series for tabularRows
        rows = rowsUtils.getRowsForSeries(rows, undefined);
      } // ** on dimension axis, config.sort can define a client side sorting, this is especially
      // required in the scenario of stack chart because sort is based on the whole stack, and
      // currently query is not able to return data rows in that sort order. Need to explicitly
      // disable hierarchy when we do a client sort.


      var forceHierarchy, hasHierarchy, summarize, sortHierarchy;
      var sortColumn;

      if (config.sorting.enabled) {
        sortColumn = config.sorting.column ? config.sorting.column[0] : undefined;
      }

      if (this.isTrellis()) {
        forceHierarchy = true;
        sortHierarchy = true;
      } else {
        hasHierarchy = sortColumn != null ? false : undefined;
        summarize = yColumns.length < keyColumns.length;
        forceHierarchy = summarize && sortColumn == null;
      }

      var tabularRows = rowsUtils.layoutTabularRows(rows, yColumns, this.getKeyFct(), {
        hasHierarchy: hasHierarchy,
        forceHierarchy: forceHierarchy,
        sortHierarchy: sortHierarchy,
        summarize: summarize,
        sorting: config.sorting
      });
      yAxisLayout = layoutsUtils.getChartCategoricalAxisLayout(dimensionAxis, tabularRows, plotOptions, autoFitMode).setHasSeries(hasSeries).setIsX(!!transforms.rotate);
    } else {
      yAxisLayout = layoutsUtils.getChartTimeAxisLayout(timeAxis, this.rows, plotOptions, autoFitMode).setIsX(!!transforms.rotate);
    } // x numeric axisLayout


    var axisLayouts = {};
    axisX.forEach(function (axis) {
      if (!axis) {
        return undefined;
      }

      var axisLayout = layoutsUtils.getChartNumericAxisLayout(axis);

      if (axisLayout) {
        axisLayout.setIsX(true).setHasNiceTicks(axis.showAxis && hasNiceDomain).setHasHorizontalTicks(!transforms.rotate).setIsNormalized(normalize).setAdjustMin(hasTime);
      }

      axisLayouts[axis.name] = axisLayout;
    });
    return _core2.default.extend(chartLayouts, {
      radiusLayout: radiusLayout,
      axisLayouts: axisLayouts,
      yAxisLayout: yAxisLayout
    });
  };

  AbstractCartesianChart.prototype._calculateMultiAxisPlotWidth = function _calculateMultiAxisPlotWidth(totalPlotWidth, numPlots) {
    return (totalPlotWidth + multiAxisPadding) / numPlots - multiAxisPadding;
  };

  AbstractCartesianChart.prototype._defaultMeasureAxes = function _defaultMeasureAxes() {
    var config = this.config;
    config.plots.forEach(function (plot, i) {
      plot.axis = plot.axis || "measureAxis" + (i + 1);
      config[plot.axis] = config[plot.axis] || {};
      config[plot.axis].name = plot.axis;

      _core2.default.defaults(config[plot.axis], getDefaultMeasureAxis());
    });
  }; // override to sanitize the config
  // Add to ctx
  // - axisX: x could have multiple axes(multi metrics), so it's a map


  AbstractCartesianChart.prototype.sanitizeConfig = function sanitizeConfig() {
    var this$1 = this;
    AbstractChart.prototype.sanitizeConfig.call(this);
    var config = this.config;

    this._defaultMeasureAxes();

    var plots = config.plots;
    var timeAxis = config.timeAxis;
    var dimensionAxis = config.dimensionAxis;
    var theme = config.theme;
    var isAxisModeMulti = this.isAxisModeMulti();
    config.mode = config.split ? constants.CHART_MODE.STACK : constants.CHART_MODE.CLUSTER;
    configUtils.convertAxisMode(config.axisMode, config); // sanitize top level options

    config.barSize = Math.max(MARK.BAR.MIN_SIZE, config.barSize);
    config.barSpacer = Math.max(MARK.BAR.MIN_SPACER, config.barSpacer);
    config.lineWidth = Math.max(MARK.LINE.MIN_LINE_WIDTH, config.lineWidth);
    config.labelSize = Math.max(MARK.LINE.MIN_LABEL_SIZE, config.labelSize);
    config.pointRadius = Math.max(MARK.LINE.MIN_POINT_RADIUS, config.pointRadius);

    if (config.r) {
      config.r.maxRadius = Math.min(Math.max(config.r.maxRadius, MARK.POINT.MIN_RADIUS), MARK.POINT.MAX_RADIUS);
    } // sanitize plots
    // - remove duplicate plot with same column
    // - set defaults
    // - valueType


    var plotByColumn = {};
    var plotsNoDup = [];
    plots.forEach(function (plot, i) {
      var column = plot.column[0] && plot.column[0].getName();
      var name = column + '/' + plot.series;

      if (plotByColumn[name]) {
        return;
      }

      plotByColumn[name] = true;
      plotsNoDup.push(plot);

      _core2.default.defaults(plot, getDefaultPlot());

      this$1._sanitizeValueType(plot, config.normalize);

      if (!colorUtils.isValidColorConfig(plot.color)) {
        plot.color = configUtils.getPaletteColor(theme, i, plots.length);
      }
    });
    config.plots = plots = plotsNoDup; // mark type dependent

    var hasBar = _core2.default.map(plots, "mark").indexOf(MARK_TYPE.BAR) > -1;

    if (hasBar) {
      // combination bar-line chart does not have fill area under line (in non small multiple mode)
      config.fillArea = !!isAxisModeMulti;
    } // sanitize dimensionAxis, timeAxis and color
    // - when timeAxis
    //   - if color by a dimension, force stacking
    // - with bar plots
    //   - when stack - take color column out of dimension columns
    //   - when cluster - always have color column in dimension columns
    // - line/dot plots only
    //   - always take color column out of dimension columns


    var colorColumn = configUtils.getPlotColorColumn(config);
    var timeColumn = configUtils.getColumns(config, "timeAxis")[0];
    var color = this.getPlot().color;

    if (color.type === CHART_LAYOUT.COLOR_TYPE.CATEGORICAL && colorColumn) {
      if (timeColumn) {
        config.mode = constants.CHART_MODE.STACK;

        if (!config.split) {
          config.split = configUtils.createDefaultSplitConfig(color);
        }
      }
    } //sanitize normalize - only allow normalize for stacked charts


    config.normalize = config.normalize && config.mode === constants.CHART_MODE.STACK; // sanitize dimensionAxis, timeAxis title

    configUtils.sanitizeAxis(timeAxis, timeAxis.column);
    configUtils.sanitizeAxis(dimensionAxis, dimensionAxis.column); // sanitize measureAxis

    if (isAxisModeMulti) {
      // for small multiples, if all measure axis/tile are hidden adjust layout
      var showAxis = false;
      var showTitle = false;
      plots.forEach(function (plot) {
        var axis = config[plot.axis];
        configUtils.sanitizeAxis(axis, plot.column, true);
        showAxis = showAxis || axis.showAxis;
        showTitle = showTitle || axis.showTitle;
      });
      config.layout = configUtils.addLegacyLayout({
        showAxis: showAxis,
        showTitle: showTitle
      }, {
        showAxis: false,
        showTitle: false
      }, dimensionAxis, timeAxis);
    } else {
      MEASURE_AXIS.forEach(function (axisName, i) {
        var axis = config[axisName];
        var columns = configUtils.getColumns(_core2.default.filter(plots, {
          axis: axisName
        }));

        if (columns.length) {
          // axis is actually used
          configUtils.sanitizeAxis(axis, columns, true);
        } else {
          // axis not used
          delete config[axisName];
        }
      }); // add back config.layout legacy section for layoutBuilder to setup initial cell grids

      config.layout = configUtils.addLegacyLayout(config.measureAxis1, config.measureAxis2, dimensionAxis, timeAxis);
    }
  }; //sanitize valueType
  // - undefined -> none if line; compactNumber or percent if normalize


  AbstractCartesianChart.prototype._sanitizeValueType = function _sanitizeValueType(plot, normalize) {
    var valueType = plot.valueType;
    valueType = valueType || (normalize ? VALUETYPE.PERCENT : plot.mark === MARK_TYPE.LINE ? VALUETYPE.NONE : VALUETYPE.COMPACT_NUMBER);
    plot.valueType = valueType;
  }; // Compute yAxisLayout with the following information
  // - barSize: final bar size after fitting
  // - plotOffsets: offset value of each layer of marks
  // - plotSize: total size of plot, used to decide whether needs to scroll and shrink plot cell to fit
  // - scale:
  //     categorical - categorical scale for label positioning
  //     time - linear scale for plot mark positioning
  // - categories:
  //     categorical - category map, keys are label keys, value is the row index.
  //          e.g. { US: 0, AP: 1, EU: 2 } used to determine in multimetrics line chart, whether to connect two line points.
  //     time - category map, keys are all epoch values at each grain unit between time range
  //          e.g. { min's epoch: 0, min's next day epoch: 1, ... max's epoch: 100 } (granularity is day)
  //          used by determine whehter two line points should be connected or not(whehter there are time units
  //          skipped between them on time scale)
  // - getCategories: call back to return the above, also providing call back because when there are series(combo stackbar + line)
  // the aggregate line is on a different set of categories. We always return the categories of the last column(the grainest) above.


  AbstractCartesianChart.prototype._getYAxisRenderConfig = function _getYAxisRenderConfig(config, scene, ctx, cellMap) {
    var barSize = config.barSize;
    var labelSize = config.labelSize;
    var autoFitMode = config.autoFitMode;
    var showCrosshair = config.showCrosshair;
    var ref = this.chartProperties;
    var cellSizes = ref.cellSizes;
    var timeColumn = ref.timeColumn;
    var marks = ref.marks;
    var hasTime = ref.hasTime;
    var timeAxis = config.timeAxis;
    var dimensionAxis = config.dimensionAxis;
    var ref$1 = this.chartLayouts;
    var yAxisLayout = ref$1.yAxisLayout;
    runtime.getPerf().mark("layout");
    var axis = hasTime ? timeAxis : dimensionAxis;
    var axisSize = cellMap.plot.get("h"); // adjust cell layout specifically for time axis

    var additionalWidth = config.transforms.rotate ? TITLE_OFFSET : 0;

    if (axis.showTitle) {
      cellMap.axisYTitle.adjustWidth((hasTime ? constants.AXIS.TIME.TITLE.HEIGHT * timeAxis.titleMaxLines : constants.AXIS.LABELS.TITLE.HEIGHT * dimensionAxis.titleMaxLines) + additionalWidth);
    } else {
      cellMap.axisYTitle.adjustColumnToFit();
    }

    if (hasTime) {
      cellMap.padding.adjustColumnToFit();
    } // compute layoutInfo


    var layoutInfo = yAxisLayout.setSize(axisSize).setWidth(cellMap.axisY.get("w")).getLayoutInfo(); // suppress scroll

    if (!yAxisLayout.needsScroll()) {
      cellMap.plot.set({
        scrollY: false
      });
      cellMap.axisY.set({
        scrollY: false
      });
    } // export autoFitRatio


    var autoFitRatio;

    if (autoFitMode !== constants.AUTOFIT_MODE.SCROLL) {
      if (marks.indexOf(MARK.BAR) > -1) {
        // chart with bars, ratio is how much barSize grow
        autoFitRatio = layoutInfo.plot.barSize / barSize;
      } else {
        // lines only, distance between points
        autoFitRatio = layoutInfo.plot.labelSize / labelSize;
      }
    } else {
      autoFitRatio = 1;
    }

    config._autoFitRatio = autoFitRatio;
    runtime.getPerf().endMark("layout");

    if (hasTime) {
      return {
        type: constants.CELL_RENDERER_TYPE.TIME,
        orientation: "y",
        scale: layoutInfo.scale,
        drawAxis: yAxisLayout.showAxis(),
        granularity: yAxisLayout.getGranularity(),
        formats: yAxisLayout.getFormats(),
        isDiscrete: yAxisLayout.isDiscrete(),
        firstDayOfWeek: yAxisLayout.getFirstDayOfWeek(),
        formatter: timeColumn && timeColumn.getFormatter(),
        showCrosshair: showCrosshair
      };
    } else {
      // hide padding column if labels will be hidden and we are not trying to fix the size of the labels column
      if (layoutInfo.axis.layout === constants.AXIS.LABELS.LAYOUT.HIDDEN && !cellSizes.axisY) {
        scene.adjustColumnToFit(cellMap.padding.get("column"));
      }

      return {
        type: constants.CELL_RENDERER_TYPE.DIMENSION,
        orientation: "y",
        layout: layoutInfo.axis.layout,
        numColumns: layoutInfo.axis.numColumns,
        rows: yAxisLayout.getRows(),
        showSeparationLines: yAxisLayout.hasHierarchy(),
        // always align middle instead of floating top/left when autoFit
        floating: autoFitMode !== constants.AUTOFIT_MODE.FIT,
        overflowForSlanted: cellMap.axisY.get("y"),
        icon: dimensionAxis.icon,
        resizeCell: !cellSizes.axisY,
        scale: layoutInfo.scale,
        showCrosshair: showCrosshair
      };
    }
  };

  AbstractCartesianChart.prototype.plot = function plot(config, rows, scene, ctx) {
    var ref = this.chartProperties;
    var axisX = ref.axisX;
    var axisY = ref.axisY;
    var hasTime = ref.hasTime;
    var transforms = config.transforms;
    var theme = config.theme;
    var isAxisModeMulti = this.isAxisModeMulti();
    var cellMap = sceneUtils.cellMap(scene);

    if (transforms.rotate && axisX[0] && axisX[0].showAxis) {
      if (!isAxisModeMulti) {
        cellMap.measureAxis1.adjustHeight(plotUtils.getMeasureAxisCellHeight(axisX[0].format));
      } else {
        var maxHeight = axisX.reduce(function (maxHeight, axis) {
          return Math.max(maxHeight, plotUtils.getMeasureAxisCellHeight(axis.format));
        }, 0);
        cellMap.measureAxis1.adjustHeight(maxHeight);
      }
    }

    if (isAxisModeMulti || !axisX[1]) {
      cellMap.measureAxis2.adjustRowToFit();
      cellMap.measureAxis2Title.adjustRowToFit();
    } else if (transforms.rotate && axisX[1].showAxis) {
      cellMap.measureAxis2.adjustHeight(plotUtils.getMeasureAxisCellHeight(axisX[1].format));
    }

    var axisYCellRendererConfig = this._getYAxisRenderConfig(config, scene, ctx, cellMap);

    var isVertical = config.transforms.rotate;
    this.cellRenderingOrder = ["axisY", "plot", "axisYTitle"];
    this.cellRendererConfigs = {
      axisY: axisYCellRendererConfig,
      plot: {
        createLayer: false
      },
      axisYTitle: {
        type: constants.CELL_RENDERER_TYPE.TITLE,
        orientation: "y",
        axis: axisY,
        isDimension: true,
        titleColor: hasTime ? theme.getTimeAxisTitleColor() : undefined,
        // add offset to make X and Y axis have approximately consistent padding between axis title and axis labels
        titleOffset: isVertical ? TITLE_OFFSET : 0
      }
    };
    AbstractChart.prototype.plot.call(this, config, rows, scene, ctx);
  };

  AbstractCartesianChart.prototype.plotCell = function plotCell(ref) {
    var this$1 = this;
    var cell = ref.cell;
    var rows = ref.rows;
    var config = ref.config;
    var ctx = ref.ctx;
    var lineWidth = config.lineWidth;
    var missingValue = config.missingValue;
    var normalize = config.normalize;
    var plots = config.plots;
    var pointRadius = config.pointRadius;
    var showPoints = config.showPoints;
    var split = config.split;
    var theme = config.theme;
    var timeAxis = config.timeAxis;
    var autoFitMode = config.autoFitMode;
    var ref$1 = this.chartProperties;
    var isStack = ref$1.isStack;
    var hasSeries = ref$1.hasSeries;
    var hasTime = ref$1.hasTime;
    var yColumns = ref$1.yColumns;
    var radiusColumn = ref$1.radiusColumn;
    var splitColumn = ref$1.splitColumn;
    var ref$2 = this.chartLayouts;
    var colorLayout = ref$2.colorLayout;
    var radiusLayout = ref$2.radiusLayout;
    var axisLayouts = ref$2.axisLayouts;
    var yAxisLayout = ref$2.yAxisLayout;
    var yAxisLayoutInfo = yAxisLayout.getLayoutInfo();
    var plotLayoutInfo = yAxisLayoutInfo.plot;
    var accessibility = {
      value: {
        type: constants.ACCESSIBILITY.TYPE.DATA
      }
    };
    var colorColumn = configUtils.getPlotColorColumn(config); // Scales

    var colorScale;
    var isAxisModeMulti = this.isAxisModeMulti();
    colorScale = colorLayout.getScale();
    var radiusScale = radiusLayout.getScale();
    var yScale = yAxisLayout.getScale();
    var keyFct = this.getKeyFct(); // - plot shapes

    var plotsInfo = [];
    plots.forEach(function (plot, i) {
      if (config.color != plots[i].color) {
        colorLayout = layoutsUtils.getChartColorLayout(config.plots[i].color, configUtils.getPaletteColor(theme, i, plots.length), rows, theme);
        colorScale = colorLayout.getScale();
      }

      var axis = plot.axis;
      var mark = plot.mark;
      var aggregationLevel = plot.aggregationLevel;
      var series = plot.series;
      var totals = plot.totals;
      var valueType = plot.valueType;
      var column = plot.column[0];
      var params, layer; // if there are more than one dimensions, we do not want the percent group to include the last dimension

      var formatInfo = plotUtils.getFormatInfo(valueType, column);
      var offset = plotLayoutInfo.offsets[i];
      var plotRows = rowsUtils.filterOutRowsWithMissingFields(rows, column, radiusColumn);

      if (hasSeries) {
        plotRows = rowsUtils.getRowsForSeries(plotRows, series);
      }

      var dataFct = function dataFct(row) {
        return {
          row: row,
          column: column.getName()
        };
      };

      switch (mark) {
        case MARK_TYPE.BAR:
          params = {
            key: {
              value: keyFct
            },
            x: {
              value: 0
            },
            y: hasTime ? {
              field: yColumns,
              defaultValue: time.getConstantEpoch(),
              scale: yScale,
              useParsedData: true
            } : {
              value: keyFct,
              scale: yScale
            },
            w: {
              field: column
            },
            h: {
              value: plotLayoutInfo.barSize
            },
            text: formatInfo.textFct,
            data: {
              value: dataFct
            },
            textInside: {
              value: isStack
            },
            textCenter: {
              value: isStack
            },
            textColorLight: {
              value: theme.getTextColorOnLight()
            },
            textColorDark: {
              value: theme.getTextColorOnDark()
            },
            fill: {
              field: colorColumn,
              scale: colorScale
            },
            layout: isStack ? {
              field: yColumns,
              type: "stackX",
              measure: column,
              stack: split,
              normalize: normalize
            } : null,
            accessibility: accessibility
          };
          layer = plotUtils.rect(params, plotRows).set({
            key: column.getName()
          });
          break;

        case MARK_TYPE.LINE:
          var stroke, areaParams;
          var lineLabelColumns = hasTime ? yColumns : this$1.getInternalKeyColumn();
          var categories = yAxisLayoutInfo.categories;
          var area = plot.area;
          var lineStyle = plot.lineStyle;
          var isDashed = lineStyle === "dashed"; // TODO: implement aggregationLevel > 1

          if (aggregationLevel == 1) {
            if (!hasTime) {
              // For totals, we are ignoring the last level (totals are for the last group)
              // Note that if we already stacked, the labels are already ignoring the last level...
              lineLabelColumns = yColumns;

              if (!isStack) {
                lineLabelColumns = yColumns.slice(0, yColumns.length - 1); // TODO dda in mixedCombo mode, cluster and only one dimension (so, only one dot), dot needs to be at center
              }

              categories = yAxisLayout.getCategories(Math.max(lineLabelColumns.length - 1, 0));
              yScale = yAxisLayout.getScale(lineLabelColumns.length - 1);
            }

            stroke = {
              field: colorColumn,
              scale: colorScale
            };
          } else {
            stroke = {
              field: colorColumn,
              scale: colorScale
            };
          }

          params = {
            key: {
              value: keyFct
            },
            x: {
              field: column
            },
            y: {
              field: lineLabelColumns,
              defaultValue: time.getConstantEpoch(),
              scale: yScale,
              useParsedData: hasTime
            },
            lines: splitColumn ? {
              field: splitColumn
            } : null,
            predictiveLine: timeAxis.predictiveLine,
            data: {
              value: dataFct
            },
            stroke: stroke,
            showPoints: showPoints,
            pointRadius: pointRadius,
            lineWidth: isDashed ? DASHED_LINE_WIDTH : lineWidth,
            dashed: isDashed ? DASHED : undefined,
            categories: categories,
            missingValue: missingValue,
            accessibility: accessibility
          };
          layer = plotUtils.line(params, plotRows).set({
            key: column.getName(),
            canSelect: !totals
          }); // Needs two measures to form an area

          if (area && area.length > 1) {
            areaParams = {
              y: {
                field: lineLabelColumns,
                defaultValue: time.getConstantEpoch(),
                scale: yScale,
                useParsedData: hasTime
              },
              groups: colorColumn ? {
                field: colorColumn
              } : null,
              stroke: stroke
            };
            plotUtils.area(area, areaParams, plotRows, layer);
          }

          break;

        case MARK_TYPE.DOT:
          var showValues = valueType !== VALUETYPE.NONE;
          params = {
            defaultValue: time.getConstantEpoch(),
            key: {
              value: keyFct
            },
            x: {
              field: column
            },
            y: hasTime ? {
              field: yColumns,
              defaultValue: time.getConstantEpoch(),
              scale: yScale,
              useParsedData: true
            } : {
              value: keyFct,
              scale: yScale
            },
            data: {
              value: dataFct
            },
            r: {
              field: radiusColumn,
              scale: radiusScale
            },
            stroke: {
              field: colorColumn,
              scale: colorScale
            },
            fill: {
              field: colorColumn,
              scale: colorScale
            },
            lineWidth: {
              value: 1
            },
            accessibility: accessibility
          };
          layer = plotUtils.point(params, plotRows).set({
            key: column.getName()
          });
          plotUtils.adjustPointFill(layer.getChildren(), radiusLayout, MARK.DOT.OPACITY_POS_VALUE, MARK.DOT.OPACITY_NEG_VALUE);

          if (radiusColumn) {
            layer.sortBy(function (p) {
              return -p.get("r");
            });
          }

          if (showValues && radiusColumn) {
            plotUtils.addValueText(layer, radiusColumn, config);
          }

          break;

        default:
          throw new Error("invalid mark type" + mark);
      } // de-duplicate plot layers


      var key = layer.getKey();

      if (cell.layerByKey(key)) {
        layer.set('key', key + i);
      }

      layer.appendTo(cell).forEach(function (shape) {
        return shape.offsetY(offset);
      });
      axisLayouts[axis].addPlot(layer.getChildren());
      plotsInfo.push({
        axis: axis,
        column: column,
        layer: layer,
        mark: mark,
        offset: offset,
        valueType: valueType
      });
    });
    ctx.plotsInfo = plotsInfo;
    this.plotWidth = this._calculateMultiAxisPlotWidth(cell.get("w"), isAxisModeMulti ? plots.length : 1);

    if (autoFitMode !== constants.AUTOFIT_MODE.FIT && autoFitMode !== constants.AUTOFIT_MODE.KEEP_LABELS) {
      cell.adjustRowToFit();
    }
  };

  AbstractCartesianChart.prototype.settleLayouts = function settleLayouts() {
    var ref = this.chartLayouts;
    var axisLayouts = ref.axisLayouts;
    var ref$1 = this.config;
    var alignTicks = ref$1.alignTicks;
    this.settleAxisLayouts(axisLayouts, this.plotWidth, !this.isAxisModeMulti(), alignTicks);
    AbstractChart.prototype.settleLayouts.call(this);
  };

  AbstractCartesianChart.prototype._drawAxis = function _drawAxis(key, axis, cell, titleCell, plotCell, scale, drawGridLines, normalize, offsetX, flipY, plotWidth, plotSize, scene, config, rows, adjustToFit) {
    // measure axis title
    var gridLineLength = plotCell.get("h");
    this.renderCell(titleCell, {
      type: constants.CELL_RENDERER_TYPE.TITLE,
      orientation: "x",
      size: plotWidth,
      key: key + "title",
      axis: axis,
      normalize: normalize,
      isDimension: false,
      offsetX: offsetX,
      adjustToFit: adjustToFit
    }, {
      scene: scene,
      rows: rows
    });
    this.renderCell(cell, {
      type: constants.CELL_RENDERER_TYPE.MEASURE,
      orientation: "x",
      key: key,
      axis: axis,
      scale: scale,
      gridLineLength: gridLineLength,
      drawGridLines: drawGridLines,
      drawAxisLine: !drawGridLines,
      normalize: normalize,
      offsetX: offsetX,
      adjustToFit: adjustToFit
    }, {
      scene: scene,
      rows: rows
    }); // draw refline if needed

    var refLineLayer;

    if (axis.referenceLines) {
      refLineLayer = referenceLineUtils.xRefLines({
        key: 'reflines-' + key,
        cell: plotCell,
        length: gridLineLength,
        lines: axis.referenceLines,
        scale: scale,
        theme: config.theme,
        formatMultiplier: configUtils.getFormatMultiplier(axis),
        rotateLabel: false
      });

      if (flipY) {
        refLineLayer.flipY();
      }

      refLineLayer.offsetX(offsetX);
      var xRange = scale.range();
      refLineLayer.set({
        viewport: [refLineLayer.get("x") + xRange[0], 0, xRange[1] - xRange[0], plotSize]
      });
    }

    if (flipY) {
      cell.flipY();
    }
  }; // Draw numeric axes and titles


  AbstractCartesianChart.prototype.postPlot = function postPlot(config, rows, scene, ctx) {
    var this$1 = this;
    var MIN_TEXT_W = 8; // "1": w ≈ 7.3px for text size 12px

    var MIN_TEXT_H = 12; // "1": h = 12px for text size 12px

    var normalize = config.normalize;
    var theme = config.theme;
    var fillArea = config.fillArea;
    var transforms = config.transforms;
    var ref = this;
    var plotWidth = ref.plotWidth;
    var plotsInfo = ctx.plotsInfo;
    var ref$1 = this.chartProperties;
    var hasTime = ref$1.hasTime;
    var axisX = ref$1.axisX;
    var axisY = ref$1.axisY;
    var timeColumn = ref$1.timeColumn;
    var ref$2 = this.chartLayouts;
    var axisLayouts = ref$2.axisLayouts;
    var yAxisLayout = ref$2.yAxisLayout;
    var yAxisLayoutInfo = yAxisLayout.getLayoutInfo();
    var plotSize = yAxisLayoutInfo.plot.plotSize;
    var cellMap = sceneUtils.cellMap(scene);
    var plotCell = scene.cellByKey("plot");
    var rotated = !!transforms.rotate;
    var isAxisModeMulti = this.isAxisModeMulti();
    var timeBrushInfo = {};

    if (timeColumn) {
      var scale = yAxisLayoutInfo.scale;
      timeBrushInfo.type = 'time';
      timeBrushInfo.dataGranularity = timeColumn.getGranularity();
      timeBrushInfo.format = timeColumn.getFormat();
      timeBrushInfo.scale = scale;
      timeBrushInfo.firstDayOfWeek = timeColumn.getFirstDayOfWeek();
    }

    runtime.getPerf().mark("axis"); // - compute the cellMap.plot full height and adjust cellMap.plot
    // height accordingly so that the cell doesn't stretch all
    // the way down if we just have a few bars/line points

    var paddingLayer = new Layer({
      key: "padding"
    }).append(new Point({
      key: "padding",
      x: 0,
      y: plotSize,
      r: 0,
      fill: "#000"
    }));
    var axisScales = {};
    (0, _keys2.default)(axisLayouts).map(function (key) {
      var axisLayout = axisLayouts[key];
      var axisScale = axisLayout && axisLayout.getScale();
      axisScales[key] = axisScale;
    });
    var allLineLabels = [];
    plotsInfo.forEach(function (plotInfo, i) {
      var axis = plotInfo.axis;
      var mark = plotInfo.mark;
      var offset = plotInfo.offset;
      var layer = plotInfo.layer;
      var column = plotInfo.column;
      var valueType = plotInfo.valueType;
      var axisLayout = axisLayouts[axis];
      var axisScale = axisScales[axis];
      layer.set({
        scales: {
          x: axisScale
        }
      }); // offset layer when small multiples

      if (isAxisModeMulti) {
        layer.offsetX((plotWidth + multiAxisPadding) * i);
      }

      var xRange = axisScale.range();
      var yRange = yAxisLayoutInfo.scale.range();

      if (mark === MARK_TYPE.LINE) {
        // adjust line fill area
        if (fillArea) {
          plotUtils.adjustLineFill(layer, false, theme.getLineFillAreaColor().toRGBA().a, axisLayout.showZero(), axisScale);
        } // Add value label for each point


        var viewportSize = {
          w: xRange[1] - xRange[0],
          h: plotSize
        };
        var labelSizeY = rotated ? MIN_TEXT_W : MIN_TEXT_H;
        var labelSizeX = rotated ? MIN_TEXT_H : MIN_TEXT_W;
        var numPoints = layer.find({
          type: "Point"
        }).length; // For performance, don't create labels if it is much overlapping among labels in both x, y.  Overlapped labels will then be hidden

        if (valueType !== VALUETYPE.NONE && (yAxisLayoutInfo.plot.labelSize > labelSizeY / 2 || viewportSize.w / numPoints > labelSizeX / 2)) {
          var labelsInfo = plotUtils.addPointValueLabel(layer, theme, rotated, valueType, column, viewportSize);

          if (isAxisModeMulti) {
            allLineLabels.push(labelsInfo);
          } else {
            allLineLabels[0] = (allLineLabels[0] || []).concat(labelsInfo);
          }
        }
      } // adjust bar text orientation or hide text


      if (mark === MARK_TYPE.BAR && valueType !== VALUETYPE.NONE) {
        plotUtils.adjustBarText(plotCell.getChildren(), scene.get("transforms").rotate, yAxisLayoutInfo.plot.barSize, MARK.BAR.TEXT_PADDING, MARK.BAR.TEXT_SIZE);
      } // setup viewport and brush info


      var brushKey = isAxisModeMulti ? "brush-" + layer.key : "brush-" + layer.getParent().key;
      layer.set({
        viewport: [layer.get("x") + xRange[0], 0, xRange[1] - xRange[0], plotSize],
        brush: _core2.default.extend({
          key: brushKey,
          area: {
            width: xRange[1],
            height: yRange[yRange.length - 1] - (offset || 0)
          },
          color: {
            stroke: theme.getBrushStrokeColor(),
            fill: theme.getBrushFillColor(),
            text: theme.getBrushTextColor()
          }
        }, timeBrushInfo)
      });
    });
    allLineLabels.forEach(function (labels) {
      plotUtils.adjustLineLabels(labels);
    });
    plotCell.append(paddingLayer).adjustRowToFit(); // For Axis x, reflines, titles

    axisX.forEach(function (axis, i) {
      if (!axis) {
        return;
      }

      var drawGridLines = isAxisModeMulti || !axisX[0] || !axisX[1];
      var cell = isAxisModeMulti || !i ? cellMap.measureAxis1 : cellMap.measureAxis2;
      var titleCell = isAxisModeMulti || !i ? cellMap.measureAxis1Title : cellMap.measureAxis2Title;
      var offsetX = isAxisModeMulti ? (plotWidth + multiAxisPadding) * i : 0;
      var flipY = !isAxisModeMulti && i === 1; // @bug W-4798194: when the axes are all on the same line only adjust to fit once we are done rendering all axes

      var adjustToFit = !isAxisModeMulti || i == axisX.length - 1;

      this$1._drawAxis("axis" + i, axis, cell, titleCell, plotCell, axisScales[axis.name], drawGridLines, normalize, offsetX, flipY, plotWidth, plotSize, scene, config, rows, adjustToFit);
    });
    runtime.getPerf().endMark("axis"); // For time Axis, reference lines and predictive line

    if (hasTime) {
      var plot = cellMap.plot;

      var timeRefLinesLayer = this._drawTimeReferenceLines(config, plot, yAxisLayoutInfo.scale);

      this._changeLineStyleAfterPredictiveLine(config, plot, timeColumn.getParser(), yAxisLayoutInfo.scale);

      timeRefLinesLayer && timeRefLinesLayer.set({
        viewport: [timeRefLinesLayer.get("x"), 0, plot.get("w"), plotSize]
      });
    }
  };

  AbstractCartesianChart.prototype._drawTimeReferenceLines = function _drawTimeReferenceLines(config, plot, scale) {
    var theme = config.theme;
    var timeAxis = config.timeAxis;
    var predictiveLine = timeAxis.predictiveLine;
    var referenceLines = timeAxis.referenceLines;

    if (referenceLines && referenceLines.length || predictiveLine) {
      // combine reference lines and predictive line into a single array.
      var lines = predictiveLine && referenceLines ? referenceLines.concat(predictiveLine) : predictiveLine ? [predictiveLine] : referenceLines;
      return referenceLineUtils.yRefLines({
        cell: plot,
        key: "reflines-timeaxis",
        scale: scale,
        length: plot.get("w"),
        lines: lines,
        theme: theme,
        rotateLabel: true
      }).flipY();
    }
  };

  AbstractCartesianChart.prototype._changeLineStyleAfterPredictiveLine = function _changeLineStyleAfterPredictiveLine(config, plot, parser, scale) {
    var this$1 = this;
    var missingValue = config.missingValue;
    var plots = config.plots;
    var timeAxis = config.timeAxis;
    var predictiveLine = timeAxis.predictiveLine;

    if (!predictiveLine) {
      return;
    } // Make all paths after the predictive line dashed


    var predLineY = scale.scale(parser(predictiveLine.time));
    var predLineStyleAfter = predictiveLine.lineStyleAfter;
    plot.forEach(function (layer, i) {
      if (plots[i] && plots[i].mark === MARK_TYPE.LINE) {
        layer.find({
          type: "Path"
        }).map(function (path) {
          return this$1._convertPredictivePath(path, predLineY, predLineStyleAfter, missingValue);
        }).filter(_core2.default.identity).forEach(function (path) {
          return layer.prepend(path);
        });
      }
    });
  }; // Similar to lodash partition


  AbstractCartesianChart.prototype._partition = function _partition(list, pred) {
    var valids = [];
    var invalids = [];

    for (var i = 0; i < list.length; ++i) {
      var it = list[i];

      if (pred(it)) {
        valids.push(it);
      } else {
        invalids.push(it);
      }
    }

    return [valids, invalids];
  };

  AbstractCartesianChart.prototype._convertPredictivePath = function _convertPredictivePath(path, predLineY, predLineStyleAfter, missingValue) {
    var points = path.get('points');
    var isClosePath = path.get("closePath");
    var isLineStyleAfterDashed = predLineStyleAfter === "dashed";
    var predictivePath = null;

    if (points) {
      var ref = this._partition(points, function (ref) {
        var x = ref[0];
        var y = ref[1];
        return y >= predLineY;
      });

      var predictivePoints = ref[0];
      var regularPoints = ref[1];

      this._addDummyPointAtPredLine(predLineY, regularPoints, predictivePoints, missingValue);

      if (predictivePoints.length && !isClosePath) {
        predictivePath = path.clone().set({
          key: path.get('key') + "-predictive",
          points: predictivePoints,
          fill: undefined,
          baseX: undefined,
          baseY: undefined
        });

        if (isLineStyleAfterDashed) {
          predictivePath.set({
            dashed: DASHED,
            lineWidth: DASHED_LINE_WIDTH
          });
        }

        path.set('points', regularPoints.concat(predictivePoints.slice(0, 1)));
      }
    }

    return predictivePath;
  };

  AbstractCartesianChart.prototype._addDummyPointAtPredLine = function _addDummyPointAtPredLine(predLineY, regularPoints, predictivePoints, missingValue) {
    // When missingValue is "disconnect", the points have already been grouped into multiple paths
    if (missingValue === constants.MISSING_VALUE.DISCONNECT) {
      return;
    }

    var lastPoint = regularPoints.length && regularPoints[regularPoints.length - 1];
    var lastPointX = lastPoint[0];
    var lastPointY = lastPoint[1];
    var nextPoint = predictivePoints.length && predictivePoints[0];
    var nextPointX = nextPoint[0];
    var nextPointY = nextPoint[1]; // Connect line is a straight line between the last point and the next point
    // Cumulative line is extended horizontally

    var predLineX = missingValue === constants.MISSING_VALUE.CONNECT ? (nextPointX - lastPointX) / (nextPointY - lastPointY) * (predLineY - lastPointY) + lastPointX : lastPointX; // Ensure the dummy to be added is between the last point and the next point.

    if (lastPointY < predLineY && predLineY < nextPointY) {
      predictivePoints.unshift([predLineX, predLineY]);
    }
  };

  return AbstractCartesianChart;
}(_index2.default);

exports.default = AbstractCartesianChart;

var getMetadata = function getMetadata() {
  return _metadata2.default;
};

exports.getMetadata = getMetadata;